<template>
  <nav class="navbar navbar-expand-lg fixed-top" aria-label="Main navigation">
    <div class="container">
      <a class="navbar-brand" href="/home">Pixel<span>ated</span></a>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/#diensten" @click="closeMenu">{{ $t('nav.services') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/portfolio" @click="closeMenu">{{ $t('nav.portfolio') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/werkwijze" @click="closeMenu">{{ $t('nav.process') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/#over-mij" @click="closeMenu">{{ $t('nav.about') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/#hosting" @click="closeMenu">{{ $t('nav.hosting') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/#contact" @click="closeMenu">{{ $t('nav.contact') }}</router-link>
          </li>
        </ul>

        <div class="lang-switcher ms-lg-3">
          <button
            class="lang-btn"
            :class="{ active: locale === 'nl' }"
            @click="setLocale('nl')"
          >NL</button>
          <span class="lang-divider">|</span>
          <button
            class="lang-btn"
            :class="{ active: locale === 'en' }"
            @click="setLocale('en')"
          >EN</button>
        </div>

        <router-link class="btn-nav-cta ms-lg-3" to="/#contact" @click="closeMenu">{{ $t('nav.cta') }}</router-link>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { locale } = useI18n()
const router = useRouter()

function setLocale(lang) {
  locale.value = lang
  localStorage.setItem('lang', lang)
}

function closeMenu() {
  const navEl = document.getElementById('navbarNav')
  if (navEl && navEl.classList.contains('show')) {
    window.bootstrap?.Collapse.getInstance(navEl)?.hide()
  }
}

router.afterEach(() => {
  closeMenu()
})
</script>

<style scoped>
.navbar {
  background-color: rgba(10, 10, 10, 0.72);
  backdrop-filter: blur(16px) saturate(140%);
  -webkit-backdrop-filter: blur(16px) saturate(140%);
  border-bottom: 1px solid var(--border);
  padding: 0.875rem 0;
  transition: background 0.3s, box-shadow 0.3s, border-color 0.3s;
}

.navbar-brand {
  font-family: 'JetBrains Mono', 'Courier New', monospace;
  font-size: 1.45rem;
  font-weight: 700;
  color: #fff;
  text-decoration: none;
  letter-spacing: -0.5px;
}

.navbar-brand span {
  color: var(--accent);
  text-shadow: 0 0 20px var(--accent-glow);
}

.navbar-brand:hover {
  color: #fff;
  text-decoration: none;
}

.nav-link {
  color: rgba(255, 255, 255, 0.65) !important;
  font-weight: 500;
  font-size: 0.9rem;
  padding: 0.5rem 0.875rem !important;
  transition: color 0.2s;
}

.nav-link:hover,
.nav-link.router-link-active {
  color: #fff !important;
}

.navbar-toggler {
  border-color: rgba(255, 255, 255, 0.25);
  padding: 0.375rem 0.625rem;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255%2C255%2C255%2C0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

/* ─── Language switcher ──────────────────────── */
.lang-switcher {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.lang-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.78rem;
  font-weight: 600;
  font-family: 'JetBrains Mono', monospace;
  cursor: pointer;
  padding: 0.25rem 0.375rem;
  letter-spacing: 0.5px;
  transition: color 0.2s;
  line-height: 1;
}

.lang-btn:hover {
  color: rgba(255, 255, 255, 0.8);
}

.lang-btn.active {
  color: var(--accent);
}

.lang-divider {
  color: rgba(255, 255, 255, 0.15);
  font-size: 0.7rem;
}

/* ─── CTA button ─────────────────────────────── */
.btn-nav-cta {
  display: inline-block;
  background: var(--accent-grad);
  color: #0a0a0a !important;
  padding: 0.55rem 1.35rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 700;
  text-decoration: none !important;
  box-shadow: 0 4px 20px var(--accent-glow);
  transition: box-shadow 0.2s, transform 0.15s, filter 0.2s;
  white-space: nowrap;
}

.btn-nav-cta:hover {
  filter: brightness(1.06);
  transform: translateY(-1px);
  box-shadow: 0 6px 28px var(--accent-glow);
}

@media (max-width: 991px) {
  .navbar-collapse {
    padding: 0.75rem 0 0.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    margin-top: 0.5rem;
  }

  .nav-link {
    padding: 0.5rem 0 !important;
  }

  .lang-switcher {
    margin-top: 0.75rem;
  }

  .btn-nav-cta {
    margin-top: 0.75rem;
    display: inline-block;
    padding: 0.5rem 1.25rem;
  }
}

@media (max-width: 767px) {
  .navbar {
    padding: 0.75rem 0;
  }

  .navbar-brand {
    font-size: 1.25rem;
  }
}
</style>
